// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2Tww7","col":"CardReaderDesc_col__28ho6","label":"CardReaderDesc_label__f8iS6"};